module.exports = __webpack_public_path__ + "static/media/planetz2.18ebe715.png";